import { UploadOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import React, { useState } from 'react';

import './image-input.less';

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

const ImageInput = ({ value, onChange, ...rest }) => {
  const [imgSrc, setImgSrc] = useState(value);

  return (
    <Upload
      listType="picture-card"
      className="image-uploader"
      showUploadList={false}
      beforeUpload={(file) => {
        getBase64(file, setImgSrc);
        onChange(file);
        return false;
      }}
      {...rest}
    >
      {imgSrc ? <img src={imgSrc} alt="logo" style={{ maxWidth: '100%' }} /> : (
        <div className="image-uploader__button">
          <UploadOutlined />
          <div>Upload</div>
        </div>
      )}
    </Upload>
  );
};

export default ImageInput;
